interface IconDefinition {
  svg: string;
  name: string;
}

const icons: Record<string, IconDefinition> = {
  shield: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
    name: "Shield Icon"
},
  clock: {
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`,
      name: "Clock Icon"
  },
  "check-square": {
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>`,
      name: "Check Square Icon"
  },
  users: {
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
      name: "Users Icon"
  },
  settings: {
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>`,
      name: "Settings Icon"
  },
  lock: {
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`,
      name: "Lock Icon"
  }
};

export const initWhySection = (): void => {
  // Existing icon initialization
  const iconContainers = document.querySelectorAll<HTMLElement>('.advantage-icon');

  iconContainers.forEach(container => {
      const iconName = container.dataset.icon;

      if (iconName && icons[iconName]) {
          container.innerHTML = icons[iconName].svg;
      }
  });

  // Initialize scroll-triggered animations for advantage cards
  initAdvantageAnimations();
};

/**
 * Scroll-triggered staggered animations for advantage cards
 */
function initAdvantageAnimations(): void {
  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const advantageCards = document.querySelectorAll<HTMLElement>('.advantage-card.advantage-animation');
  const timeline = document.querySelector<HTMLElement>('.why-timeline');

  if (advantageCards.length === 0) return;

  if (prefersReducedMotion) {
    // Immediately show all cards without animation
    advantageCards.forEach((card) => {
      card.classList.add('animate-in');
      const timelineItem = card.closest<HTMLElement>('.why-timeline__item');
      if (timelineItem) {
        timelineItem.classList.add('is-visible');
      }
    });
    if (timeline) {
      timeline.classList.add('is-revealed');
    }
    return;
  }

  // IntersectionObserver configuration
  const observerOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2, // Trigger when 20% of card is visible
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.classList.contains('animate-in')) {
        // Get the card index for staggered delay
        const card = entry.target as HTMLElement;
        const index = parseInt(card.dataset.advantageIndex || '0', 10);
        const delay = index * 100; // 100ms stagger between each card

        setTimeout(() => {
          card.classList.add('animate-in');
          const timelineItem = card.closest<HTMLElement>('.why-timeline__item');
          if (timelineItem) {
            timelineItem.classList.add('is-visible');
          }
        }, delay);

        if (timeline && !timeline.classList.contains('is-revealed')) {
          timeline.classList.add('is-revealed');
        }

        // Stop observing once animated
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all advantage cards
  advantageCards.forEach((card) => {
    observer.observe(card);
  });
}
